import promise from 'promise';
import api from 'app/shared/utils/api';

const TermsAndConditionsActions = {
    markAcceptedTerms() {
        return (dispatch) => {
            const params = {
                authZone: null,
                userId: null,
                termsAndConditions: [{
                    type: 'termsAcceptedZillowRentalUser',
                    version: 0,
                }],
            };

            return dispatch(api.users.termsAndConditions.markAcceptedTerms(params))
                .then((response) => {
                    if (response && response.success === false) {
                        return promise.reject(response.error);
                    }

                    return response;
                })
                .catch((error) => {
                    global.TEMPORARY_global_logger.warn('MARK_ACCEPTED_TERMS_ERROR: %s', error);
                });
        };
    },
};

export default TermsAndConditionsActions;
